'use client';

import { c as _c } from "react/compiler-runtime";
import SvgChevronright from '@common/__generated__/icon/SvgChevronright';
import { Button, Chip } from '@common/components';
import { cn } from '@core/utils';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { UnauthQueryOptions } from '@/api';
import { CustomLink } from '@/app/_components/CustomLink';
import { GiftListItem } from '@/app/_components/DonationTemp/GiftListItem';
import { GIFT_SALE_STATUS } from '@/app/donation/constants';
import { HorizontalScroll } from '@/components/client';
import { Responsive } from '@/components/organism/Responsive';
import { BREAKPOINTS, DONATION_ROUTES, STORAGE_KEY } from '@/constants';
import type { CategoryGroupGiftsData } from './CategoryGroupGiftsSectionServer';
import { CategoryGroupItem } from './CategoryGroupItem';
import { ALL_CATEGORY_GROUP_CODE, GIFT_PAGE_SIZE, GIFT_PRODUCT_SORT_TYPE, type GiftCategoryGroupCode, type GiftProductSortType, SORT_TYPE_OPTIONS } from './constants';
const DESKTOP_MAX_PER_ROW = 10;
export const CategoryGroupGiftsSection = t0 => {
  const $ = _c(47);
  const {
    className,
    categoryGroups,
    initialGifts
  } = t0;
  const [selectedGroupCode, setSelectedGroupCode] = useState(ALL_CATEGORY_GROUP_CODE);
  const [selectedSortType, setSelectedSortType] = useState(GIFT_PRODUCT_SORT_TYPE.POPULAR);
  let t1;
  let t2;
  if ($[0] !== categoryGroups) {
    t1 = () => {
      try {
        const savedGroupCode = sessionStorage.getItem(STORAGE_KEY.DONATION_HOME_SELECTED_GIFT_CATEGORY_GROUP);
        const savedGroup = categoryGroups.find(group => group.groupCode === savedGroupCode);
        if (!savedGroup) {
          return;
        }
        setSelectedGroupCode(savedGroup.groupCode);
      } catch {}
    };
    t2 = [categoryGroups];
    $[0] = categoryGroups;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const isAllGroup = selectedGroupCode === ALL_CATEGORY_GROUP_CODE;
  const appliedSortType = isAllGroup ? GIFT_PRODUCT_SORT_TYPE.POPULAR : selectedSortType;
  const isInitialQuery = isAllGroup && appliedSortType === GIFT_PRODUCT_SORT_TYPE.POPULAR;
  let t3;
  if ($[3] !== appliedSortType || $[4] !== selectedGroupCode) {
    t3 = UnauthQueryOptions["get:/wello/v2/allows/home-love/main/category-group-gift-products"]({
      query: {
        giftCategoryGroupType: selectedGroupCode,
        giftProductSortType: appliedSortType,
        page: 1,
        size: GIFT_PAGE_SIZE
      }
    });
    $[3] = appliedSortType;
    $[4] = selectedGroupCode;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = !isInitialQuery;
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = {
      ...t3,
      select: _temp,
      enabled: t4,
      placeholderData: keepPreviousData
    };
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const {
    data: giftList
  } = useQuery(t5);
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = groupCode => {
      setSelectedGroupCode(groupCode);
      try {
        if (groupCode === ALL_CATEGORY_GROUP_CODE) {
          sessionStorage.removeItem(STORAGE_KEY.DONATION_HOME_SELECTED_GIFT_CATEGORY_GROUP);
          return;
        }
        sessionStorage.setItem(STORAGE_KEY.DONATION_HOME_SELECTED_GIFT_CATEGORY_GROUP, groupCode);
      } catch {}
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const handleClickGroup = t6;
  const desktopRowCount = Math.max(1, Math.ceil(categoryGroups.length / DESKTOP_MAX_PER_ROW));
  const basePerRow = Math.floor(categoryGroups.length / desktopRowCount);
  const longRowCount = categoryGroups.length % desktopRowCount;
  let groupItems;
  let t7;
  if ($[10] !== basePerRow || $[11] !== categoryGroups || $[12] !== desktopRowCount || $[13] !== longRowCount || $[14] !== selectedGroupCode) {
    let t8;
    if ($[17] !== selectedGroupCode) {
      t8 = t9 => {
        const {
          groupCode: groupCode_0,
          groupName,
          imageUrl
        } = t9;
        return <div key={groupCode_0} className="flex-[0_0_auto]"><CategoryGroupItem imageUrl={imageUrl} groupName={groupName} active={selectedGroupCode === groupCode_0} onClick={() => handleClickGroup(groupCode_0)} /></div>;
      };
      $[17] = selectedGroupCode;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    groupItems = categoryGroups.map(t8);
    t7 = Array.from({
      length: desktopRowCount
    }, (_, rowIndex) => {
      const shortRowCount = desktopRowCount - longRowCount;
      const start = rowIndex * basePerRow + Math.max(0, rowIndex - shortRowCount);
      return groupItems.slice(start, start + basePerRow + (rowIndex >= shortRowCount ? 1 : 0));
    });
    $[10] = basePerRow;
    $[11] = categoryGroups;
    $[12] = desktopRowCount;
    $[13] = longRowCount;
    $[14] = selectedGroupCode;
    $[15] = groupItems;
    $[16] = t7;
  } else {
    groupItems = $[15];
    t7 = $[16];
  }
  const desktopRows = t7;
  const resultGiftList = isInitialQuery ? initialGifts : giftList;
  let t8;
  if ($[19] !== className) {
    t8 = cn("flex flex-col items-center px-40 content-container", "mobile-tablet:px-20", className);
    $[19] = className;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <h2 className={cn("pb-32 text-center font-800 text-Gray-900 typo-h4", "mobile-tablet:w-full mobile-tablet:pb-14 mobile-tablet:text-left mobile-tablet:font-700 mobile-tablet:typo-body1")}>🎁 꾸준히 사랑받는 답례품</h2>;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== categoryGroups.length || $[23] !== desktopRows || $[24] !== groupItems) {
    t10 = categoryGroups.length > 0 && <><Responsive.MobileOnly display="block" className="w-full pb-20"><HorizontalScroll className="-mx-20" slideClassName="pl-20">{groupItems}<span aria-hidden="true" className="w-20 shrink-0" /></HorizontalScroll></Responsive.MobileOnly><Responsive.DesktopOnly display="block" className="w-full"><div className="flex flex-col gap-16 pb-32">{desktopRows.map(_temp2)}</div></Responsive.DesktopOnly></>;
    $[22] = categoryGroups.length;
    $[23] = desktopRows;
    $[24] = groupItems;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== isAllGroup || $[27] !== selectedSortType) {
    t11 = !isAllGroup && <ul className={cn("flex items-center gap-6 pb-24", "mobile-tablet:hidden")}>{SORT_TYPE_OPTIONS.map(t12 => {
        const {
          label,
          value
        } = t12;
        return <li key={value}><Chip checked={selectedSortType === value} onClick={() => setSelectedSortType(value)}>{label}</Chip></li>;
      })}</ul>;
    $[26] = isAllGroup;
    $[27] = selectedSortType;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t10 || $[30] !== t11) {
    t12 = <header className="flex w-full flex-col items-center">{t9}{t10}{t11}</header>;
    $[29] = t10;
    $[30] = t11;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = cn("grid w-full grid-cols-4 gap-x-20 gap-y-40 pb-60", "mobile:grid-cols-2 tablet:grid-cols-3 mobile-tablet:gap-x-15 mobile-tablet:gap-y-32 mobile-tablet:pb-40");
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== resultGiftList) {
    t14 = !resultGiftList?.length ? <li className="col-span-full h-92 text-Gray-600 flex-center typo-body3">조회된 답례품이 없어요.</li> : resultGiftList.map(_temp3);
    $[33] = resultGiftList;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t14) {
    t15 = <ul className={t13}>{t14}</ul>;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== appliedSortType) {
    t16 = DONATION_ROUTES.GIFTS.withSearchParams({
      searchParams: {
        sort: appliedSortType
      }
    });
    $[37] = appliedSortType;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <SvgChevronright className="size-16 text-Gray-600" />;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t16) {
    t18 = <Button theme="sub-line" dimensions="H40" asChild={true}><CustomLink href={t16} aria-label={"\uC804\uCCB4 \uB2F5\uB840\uD488 \uBAA9\uB85D \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"} className="flex w-[30rem] max-w-full items-center gap-16">답례품 전체보기{t17}</CustomLink></Button>;
    $[40] = t16;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t12 || $[43] !== t15 || $[44] !== t18 || $[45] !== t8) {
    t19 = <section className={t8}>{t12}{t15}{t18}</section>;
    $[42] = t12;
    $[43] = t15;
    $[44] = t18;
    $[45] = t8;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  return t19;
};

// GiftListItem 공통 props
const GIFT_ITEM_RESPONSIVE_CLASSNAME = {
  institutionLogo: 'mobile-tablet:size-20',
  institutionName: 'mobile-tablet:typo-caption1 mobile-tablet:font-600',
  productName: 'mobile-tablet:typo-body4 mobile-tablet:font-500',
  donationAmount: 'mobile-tablet:typo-body3 mobile-tablet:font-700',
  donationAmountText: 'mobile-tablet:typo-body4 mobile-tablet:font-600'
} as const;
function _temp(data) {
  return data.context?.contents ?? [];
}
function _temp2(rowItems, rowIndex_0) {
  return <div key={rowIndex_0} className="flex flex-wrap justify-center gap-x-28 gap-y-16">{rowItems}</div>;
}
function _temp3(giftData) {
  return <li key={giftData.productNumber}><GiftListItem mainImageSizes={`${BREAKPOINTS.MOBILE} 50vw, ${BREAKPOINTS.TABLET} 33vw, 285px`} responsiveClassName={GIFT_ITEM_RESPONSIVE_CLASSNAME} mainImageUrl={giftData.mainImageUrl} productName={giftData.productName} donationAmount={giftData.requiredDonationAmount} reviewCount={giftData.reviewCount} reviewRating={giftData.reviewRating} institution={{
      id: giftData.institutionSlugId ?? giftData.institutionId,
      logoUrl: giftData.institutionLogoUrl,
      name: giftData.institutionName
    }} productNumber={giftData.productSlugId ?? giftData.productNumber} isNew={giftData.newDisplayYN} isAdult={giftData.adultYN} isSoldOut={giftData.productSaleStatus === GIFT_SALE_STATUS.SOLD_OUT} /></li>;
}